import { b2x } from '@b2x/react/src';

import { Container } from '../Container';
import { FooterContentType } from '../contentTypes';
import { NewsletterForm } from '../NewsletterForm';

export interface FooterNewsletterProps {}

export const FooterNewsletter = () => {
  const footerContent = b2x.useContent<FooterContentType>('FOOTER_CONTENT');
  return (
    <Container>
      <b2x.Row justifyContent={'center'}>
        <b2x.Col size={{ lg: 6, md: 8, xxl: 4 }}>
          <div aria-labelledby="newsletter-footer-title" role="region">
            <p className="h1 text-uppercase text-center mb-3" id="newsletter-footer-title">
              {footerContent?.body.newsletterTitle}
            </p>
            <div className="mb-4 fs-5 text-center">{b2x.formatHtml(footerContent?.body.newsletterContent)}</div>
            <NewsletterForm emailFieldStyle="inputGroup" source="website-footer" />
          </div>
        </b2x.Col>
      </b2x.Row>
    </Container>
  );
};
